import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchPipe } from './pipes/search.pipe';
import { NumbertowordsPipe } from './pipes/numbertowords.pipe';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ImageViewerDialogComponent } from './image-viewer-dialog/image-viewer-dialog.component';
import { MatIconModule } from "@angular/material/icon";
import { SearchBarComponent } from './search-bar/search-bar.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SearchPipe,
    NumbertowordsPipe,
    SafeUrlPipe,
    ImageViewerDialogComponent, SearchBarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    FormsModule
  ],

  exports: [
    SearchPipe,
    NumbertowordsPipe,
    SafeUrlPipe,
    SearchBarComponent
  ]
})
export class SharedModule { }
